import {CustomStructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {InsertableColumnInfo, TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import legacyRunModal from 'ui-library/legacyRunModal';

import {getColumnLabel} from '../columns/ColumnDefinitions';
import toColumnDefinition from '../columns/toColumnDefinition';
import {makeStructuredTableColumn} from '../util/StructuredTableColumnUtil';
import CustomColumnConfigModal from './CustomColumnConfigModal';
import {CustomColumnDataType} from './CustomColumnConstants';

export function createCustomColumnFromConfig(
  dataType: CustomColumnDataType,
  name: string
): InsertableColumnInfo<CustomStructuredTableColumn> {
  const structuredTableColumn: CustomStructuredTableColumn = {
    ...makeStructuredTableColumn({
      columnType: TableColumnType.CUSTOM,
      name,
    }),
    columnType: TableColumnType.CUSTOM, // needed to satisfy TypeScript
    frontEndMetadata: undefined, // needed to satisfy TypeScript
    customColumnConfig: {dataType},
  };
  const columnDefinition = toColumnDefinition({structuredTableColumn, schemas: []});
  return {
    columnLabels: getColumnLabel(columnDefinition),
    columnConstraints: {
      structuredTableColumn,
      columnDefinition,
    },
    widths: structuredTableColumn.width,
  };
}

/**
 * To be used when inserting a new custom column to a structured table.
 */
export async function runCreateCustomColumnConfigModal(): Promise<InsertableColumnInfo<CustomStructuredTableColumn> | null> {
  const modalSubmitResult = await legacyRunModal(CustomColumnConfigModal, {});
  if (modalSubmitResult == null) {
    return null;
  }
  const {name, dataType} = modalSubmitResult;

  return createCustomColumnFromConfig(dataType, name);
}
